"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MysteryBoxMintDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_dialog_form_1 = require("@dzambalaorg/mui-dialog-form");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const inputs_1 = require("../../../../../../inputs");
const box_content_1 = require("../../../box-content");
const validation_1 = require("./validation");
const MysteryBoxMintDialog = props => {
    const { initialValues, ...rest } = props;
    return ((0, jsx_runtime_1.jsxs)(mui_dialog_form_1.FormDialog, { initialValues: initialValues, validationSchema: validation_1.validationSchema, message: "dialogs.mintToken", testId: "MintForm", disabled: false, ...rest, children: [(0, jsx_runtime_1.jsx)(inputs_1.MysteryBoxInput, {}), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "account" }), (0, jsx_runtime_1.jsx)(box_content_1.BoxContent, {})] }));
};
exports.MysteryBoxMintDialog = MysteryBoxMintDialog;
//# sourceMappingURL=index.js.map